import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Refund() {
  return (
    <div className="container mx-auto px-4 py-8 max-w-5xl">
      <div className="mb-8">
        <Link to="/" className="inline-flex items-center text-blue-600 hover:text-blue-800">
          <ArrowLeft className="w-4 h-4 mr-1" />
          Back to Home
        </Link>
      </div>

      <h1 className="text-3xl font-bold mb-6">Refund Policy</h1>
      <div className="text-sm text-gray-600 mb-8">
        Last updated: April 29, 2026
      </div>

      <div className="prose prose-lg max-w-none">
        <p>
          This Refund Policy is part of and incorporated by reference into the{' '}
          <Link to="/terms" className="text-blue-600 hover:text-blue-800">Fuel Central Terms of Service</Link>. Capitalized terms used
          but not defined here have the meanings given in the Terms of Service.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-4">1. Single Valuations ($100)</h2>
        <p>
          All sales of single valuations are final once the on-screen estimate is successfully generated and displayed.
        </p>
        <p>
          We may, in our sole discretion, issue a refund in the following limited circumstances, provided you contact us within
          seven (7) days of the charge:
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li><strong>System error.</strong> The valuation failed to generate due to a system error attributable to GSL Solutions, Inc.</li>
          <li><strong>Material data error.</strong> The valuation contains a material factual error in the underlying input data.</li>
          <li><strong>Insufficient data charged in error.</strong> The subject property could not be valued due to insufficient data inputs and you were charged in error.</li>
        </ul>
        <p>We do <strong>not</strong> issue refunds for:</p>
        <ul className="list-disc pl-6 mb-4">
          <li>Dissatisfaction with the valuation estimate itself;</li>
          <li>Change of mind or buyer's remorse;</li>
          <li>Disagreement with the methodology, assumptions, or comparable selection.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8 mb-4">2. Subscriptions ($500/month)</h2>
        <p>
          You may cancel your subscription at any time through your account settings or by emailing us at the address below.
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li>Cancellation takes effect at the end of your current billing period.</li>
          <li>You retain access to any unused valuations included in your plan until the end of the billing period.</li>
          <li>We do <strong>not</strong> prorate partial billing periods.</li>
          <li>We do <strong>not</strong> refund unused valuations or partial-cycle subscription fees.</li>
          <li>Unused valuations do not roll over to the next billing period unless expressly stated.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8 mb-4">3. How to Request a Refund</h2>
        <p>Email <strong>TheFuelCentral@gmail.com</strong> with the following:</p>
        <ul className="list-disc pl-6 mb-4">
          <li>Your order number, transaction ID, or valuation ID;</li>
          <li>The reason for your refund request;</li>
          <li>Any supporting documentation (e.g., screenshots, correspondence).</li>
        </ul>
        <p>We respond to refund requests within three (3) business days.</p>

        <h2 className="text-xl font-semibold mt-8 mb-4">4. Chargebacks</h2>
        <p>
          We ask that you contact us before initiating a chargeback with your card issuer. Chargebacks initiated without prior
          good-faith contact may result in:
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li>Suspension or termination of your account;</li>
          <li>Recovery of the disputed amount and any associated fees and chargeback costs.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8 mb-4">5. Contact</h2>
        <address className="not-italic mt-2 mb-4">
          GSL Solutions, Inc.<br />
          P.O. Box 3108<br />
          Corona, CA 92878<br />
          Email: TheFuelCentral@gmail.com<br />
          Phone: 951-223-5610
        </address>
      </div>

      <div className="my-8">
        <Link to="/" className="inline-flex items-center text-blue-600 hover:text-blue-800">
          <ArrowLeft className="w-4 h-4 mr-1" />
          Back to Home
        </Link>
      </div>
    </div>
  );
}
